var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.loading
        ? _c(_setup.SvgIcon, {
            staticClass: "spin",
            attrs: { size: "14", type: "mdi", path: _setup.path.loading },
          })
        : _c(_setup.SvgIcon, {
            attrs: { size: "14", type: "mdi", path: _setup.path.layer },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }